export default class ExportSitePDFViewModel {
    reference: string = ''
    date: string = ''
    includeDevelopmentDetails: boolean = false;
    includeDayDetails: boolean = false;
    includeParking: boolean = false;
    includeTravelPlan: boolean = false;
    addUserComments: boolean = false;
    userComments: string = '';
    displayPDFtoScreen: boolean = false;
    writePDFtoFileOnServer: boolean = false;
    fileName: string = '';
}